import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'Do I need to be in shape to start?',
  answer: 'Not at all. Our classes are designed to accommodate all fitness levels. You will build strength, endurance, and flexibility progressively at your own pace.'
}, {
  question: 'Will I get hurt?',
  answer: 'Safety is our top priority. We teach proper technique, use high-quality mats and equipment, and ensure a controlled, respectful training environment.'
}, {
  question: 'What should I wear to my first class?',
  answer: 'Comfortable athletic clothing (like a t-shirt and sweatpants or leggings) is perfect for your trial class. No special gear is required to start.'
}, {
  question: 'How often should I train to see fitness results?',
  answer: 'Most students train 2 to 3 times per week. Consistency is key, and you will typically start noticing improvements in your energy, flexibility, and strength within the first few weeks.'
}];
export function FitnessFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-1420" />;
}